module.exports = __webpack_public_path__ + "img/icon_menu_more_main.82ccef7a.svg";